import type { BrpRoadmapConfig } from "@/helpers/brp-roadmap"

export const defaultBrpRoadmapConfig: BrpRoadmapConfig = {
    displayRules: {
        energy_independents: {
            clusters: [
                {
                    id: "initial-fabric-and-controls",
                    anchorStage: 1,
                    ecmKeys: ["roof", "wall_cavity", "heating_controls"],
                    omitMissing: true
                }
            ]
        }
    },
    strategyAvailabilityRules: [
        {
            id: "heat-pump-ready-from-2005",
            routeKey: "boiler_switchers",
            minConstructionYear: 2005
        }
    ]
}

export function mergeBrpRoadmapConfig(
    base: BrpRoadmapConfig,
    override?: BrpRoadmapConfig
): BrpRoadmapConfig {
    if (!override) return base

    const baseDisplayRules = base.displayRules ?? {}
    const overrideDisplayRules = override.displayRules ?? {}

    return {
        ...base,
        ...override,
        displayRules: {
            ...baseDisplayRules,
            ...Object.fromEntries(
                Object.entries(overrideDisplayRules).map(([routeKey, routeRules]) => [
                    routeKey,
                    {
                        ...baseDisplayRules[routeKey],
                        ...routeRules
                    }
                ])
            )
        }
    }
}
